import React, { Fragment, useCallback } from "react";
import { api } from "../utils/convex-api";
import { isToday } from "date-fns";
import { Text } from "react-native";
import { Id } from "@teachloop/backend/_generated/dataModel";
import TutorSessionCard from "../shared/tutor-session-card";
import { useSheet } from "../shared/sheet-provider";
import { SheetIds } from "../utils/sheet-ids";
import {
  TutorLessonSheetPayload,
  TutorLessonSheetResult,
} from "../sheets/tutor-lesson-sheet";
import { useRouter } from "expo-router";

type TutorSession = NonNullable<
  typeof api.tutor.home.queries.getSessions._returnType
>[number];

function TutorDailySessions({
  sessions,
  startDate,
}: {
  sessions: TutorSession[];
  startDate: Date;
}) {
  const { open } = useSheet<TutorLessonSheetPayload, TutorLessonSheetResult>(
    SheetIds.TUTOR_LESSON
  );
  const router = useRouter();

  const openCancelLessonScreen = useCallback(
    (payload: { id: Id<"sessions"> }) => {
      router.push(`/(app)/cancel-lesson?lessonId=${payload.id}`);
    },
    [router]
  );

  return (
    <Fragment>
      {sessions.length > 0 ? (
        <Fragment>
          {sessions.map((session) => {
            return (
              <TutorSessionCard
                key={session.sessionId}
                session={session}
                open={open}
                openCancelLessonScreen={openCancelLessonScreen}
              />
            );
          })}
        </Fragment>
      ) : (
        <Text className="font-geologica-medium text-base text-gray-800 leading-[1.2]">
          You have no lessons booked for{" "}
          {isToday(startDate) ? "today" : "this day"}
        </Text>
      )}
    </Fragment>
  );
}

export default TutorDailySessions;
